import Vue from 'vue';
import skySharethis from './sky-sharethis';
// Main component
Vue.component('sky-sharethis', skySharethis);

export default skySharethis;



// WEBPACK FOOTER //
// ./scripts/sky-sharethis/index.js